import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import { Row, Button } from 'antd';

import styles from './extraPanel.less';
import TabsMenu from '../../common/UI/TabsMenu';

import routes from '../../../routes';

import LoadingSpin from '../../common/LoadingSpin';


class ExtraHeader extends React.Component {
  static propTypes = {
    scene: PropTypes.object.isRequired,
    catalog: PropTypes.object.isRequired,
    record: PropTypes.object.isRequired,
    tabId: PropTypes.string,
    hasBeenEdit: PropTypes.bool.isRequired,
    isWebForm: PropTypes.bool,
    isNew: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }


  hideSideBar = () => {

  }

  isLoading = () => {
    const { record, tabId } = this.props;

    if (!record) {
      return false;
    }

    const TABS_IDS = {
      MAIN: 'main',
      LINKS: 'links',
      CHAT: 'chat',
      HISTORY: 'history',
      MANUAL: 'manual',
    };

    if (tabId === TABS_IDS.LINKS) {
      return record.get('linkedDataLoading');
    }
    if (tabId === TABS_IDS.HISTORY) {
      return record.getIn(['history', 'loading']);
    }

    return false;
  };

  onRefresh = () => {
    const { tabId, onRefresh } = this.props;
    onRefresh && onRefresh(tabId);
  }

  render() {
    const {
      tabs,
      tabId,
      onTabChange,
      t,
    } = this.props;

    const isLoading = this.isLoading();

    return (
      <div className={styles.header}>
        <Row type="flex" justify="space-between" align="middle" className={styles.containerHeader}>
          <h2 className={styles.headerText}>{t(`record.tabs.${tabId}`)}</h2>

          <Button onClick={this.onRefresh} title={t('buttons.refresh')}>
            <LoadingSpin spin={isLoading} className={styles.buttonRefresh} />
          </Button>
        </Row>
        <Row className={styles.tabsContainer}>
          <TabsMenu
            items={tabs}
            activeId={tabId}
            className={styles.tabs}
            onClick={onTabChange}
          />
        </Row>
      </div>
    );
  }
}

export default withTranslation()(ExtraHeader);